import {
  Button,
  Dialog,
  Pagination,
  Tooltip,
  Select,
  Option,
  Autocomplete,
  Notification,
  Message,
  MessageBox,
  Form,
  FormItem,
  Badge,
  Input,
  Breadcrumb,
  BreadcrumbItem,
  Table,
  TableColumn,
  Progress,
  Loading,
  Menu,
  MenuItem,
  Submenu,
  Popover,
  Switch
} from 'element-ui'
import './element-variables.scss'

export default {
  install(V) {
    V.use(Button)
    V.use(Dialog)
    V.use(Pagination)
    V.use(Tooltip)
    V.use(Select)
    V.use(Option)
    V.use(Autocomplete)
    V.use(Form)
    V.use(FormItem)
    V.use(Badge)
    V.use(Input)
    V.use(Breadcrumb)
    V.use(BreadcrumbItem)
    V.use(Table)
    V.use(TableColumn)
    V.use(Progress)
    V.use(Loading)
    V.use(Menu)
    V.use(MenuItem)
    V.use(Submenu)
    V.use(Popover)
    V.use(Switch)
    V.prototype.$notify = Notification
    V.prototype.$confirm = MessageBox.confirm
    V.prototype.$message = Message
  }
}